/* @flow */
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import React from 'react';

import './styles/share.scss';

export default class extends React.Component {
  static propTypes = {
    link: React.PropTypes.string.isRequired,
  };

  getLink = () => {
    return `https://www.facebook.com/sharer/sharer.php?u=${this.props.link}`;
  };

  render() {
    return (
      <Link
        target="_blank"
        href={this.getLink()}
        className={cx('Share', 'ShareFacebook', this.props.className)}>
        <Glyph
          className="Share-glyph ShareFacebook-glyph"
          size="large"
          name="facebook"
        />
        <span>Share</span>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ShareFacebook.jsx